import { useCan } from '@/domains/auth';
import { mailTemplatesApi } from '../../api/mail-templates-api';
import { useAdminData, type IAdminTab } from '../../components/admin-page';
import { TEAM_PATHS } from '../../paths';

/** Email templates' two views — the list of templates and the Design — `mail.templates` the
 *  Design's; none for an outreach author alone. */
export function useTemplateTabs(): IAdminTab[] {
  const can = useCan();
  if (!can('mail.templates')) return [];
  return [
    { to: TEAM_PATHS.mailTemplates, label: 'Templates', end: true },
    { to: TEAM_PATHS.mailDesign, label: 'Design' }
  ];
}

/** The overview's Status filter, `?status=` — absent is `active`, the templates in use. */
export const STATUS_PARAM = 'status';
export const STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'archived', label: 'Archived' },
  { value: 'all', label: 'All' }
] as const;
export type TemplateStatus = (typeof STATUSES)[number]['value'];

export function statusOf(param: Nullable<string>): TemplateStatus {
  return STATUSES.find((entry) => entry.value === param)?.value ?? 'active';
}

export function hasStatus(template: { archivedAt?: Nullable<string> }, status: TemplateStatus): boolean {
  if (status === 'all') return true;
  return Boolean(template.archivedAt) === (status === 'archived');
}

/** Every template the caller can read, the live and the archived — survey-api lists the archived
 *  instead of the live, so the two reads are joined. */
export function useEveryTemplate() {
  return useAdminData(
    async (signal) =>
      (await Promise.all([mailTemplatesApi.list(signal), mailTemplatesApi.list(signal, { archived: true })])).flat(),
    []
  );
}
